import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import './CommunityContextFloatingMenu.css';
import { CommunityContextListItemButton } from './CommunityContextFloatingMenuStyles';

const CommunityContextFloatingMenu = ({ menuItems }) => {
  return (
    <span styleName="container">
      {menuItems.map(({ label, onClick, children, selected }) => {
        return (
          <CommunityContextListItemButton
            key={label}
            onClick={onClick}
            selected={selected}
          >
            <span>{i18next.t(label, label)}</span>
            {children}
          </CommunityContextListItemButton>
        );
      })}
    </span>
  );
};

CommunityContextFloatingMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
      ]),
      onClick: PropTypes.func.isRequired
    })
  ).isRequired
};

export default CommunityContextFloatingMenu;
